class RentalService {

    constructor($http, $q, SnackbarService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.SnackbarService = SnackbarService;

        this.loaded = false;
        this.loading = false;
        this.showAllErrors = false;

        this.step = 1;

        this.product = null;

        this.shipments = [
            {
                name: 'Kurier',
                module: 1,
                on_delivery: false,
                shipment_1: true,
                shipment_2: true,
                price: 38,
                charge_deposit: true
            },
            {
                name: 'Odbiór i zwrot osobisty',
                module: 2,
                on_delivery: true,
                shipment_1: false,
                shipment_2: false,
                price: 0,
                charge_deposit: false
            },
            {
                name: 'Wysyłka kurierem i zwrot osobisty',
                module: 3,
                on_delivery: false,
                shipment_1: true,
                shipment_2: false,
                price: 19,
                charge_deposit: true
            },
            {
                name: 'Odbiór osobisty i wysyłka kurierem',
                module: 4,
                on_delivery: true,
                shipment_1: false,
                shipment_2: true,
                price: 19,
                charge_deposit: false
            }
        ];

        this.payments = [
            {
                name: 'PayU',
                module: 'payu',
                on_delivery: false
            },
            {
                name: 'Przelew',
                module: 'wire',
                on_delivery: false
            },
            {
                name: 'Płatność przy odbiorze',
                module: 'ondelivery',
                on_delivery: true
            }
        ];

        this.userData = {
            rentalPeriodFrom: null,
            rentalPeriodTo: null,
            firstName: '',
            lastName: '',
            street: '',
            houseNumber: '',
            flatNumber: '',
            zipCode: '',
            city: '',
            email: '',
            phone: '',
            comments: '',
            shipment: null,
            seriesAndNumberOfIdentityCard: '',
            secondIdentityDocument: '',
            secondIdentityDocumentType: '',
            seriesAndNumberOfSecondIdentityDocument: '',
            shipment_1: false,
            shipment_1_street: '',
            shipment_1_houseNumber: '',
            shipment_1_flatNumber: '',
            shipment_1_zipCode: '',
            shipment_1_city: '',
            shipment_2: false,
            shipment_2_street: '',
            shipment_2_houseNumber: '',
            shipment_2_flatNumber: '',
            shipment_2_zipCode: '',
            shipment_2_city: '',
            payment: null,
            acceptTerms: false
        };

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.userDataValidations = {
            rentalPeriod: () => {
                if (this.userData.rentalPeriodFrom === null) {
                    return false;
                }

                if (this.userData.rentalPeriodTo === null) {
                    return false;
                }

                let dateFrom = new Date(this.userData.rentalPeriodFrom);
                let dateTo = new Date(this.userData.rentalPeriodTo);

                const diffTime = Math.abs(dateTo - dateFrom);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

                if (diffDays < 3 || diffDays > 32) {
                    return false;
                }

                if (dateFrom.getDay() === 0 || dateTo.getDay() === 0) {
                    return false;
                }

                return true;
            },
            firstName: () => this.userData.firstName !== '',
            lastName: () => this.userData.lastName !== '',
            street: () => this.userData.street !== '',
            houseNumber: () => this.userData.houseNumber !== '',
            zipCode: () => this.userData.zipCode !== '',
            city: () => this.userData.city !== '',
            email: () => emailRegex.test(String(this.userData.email).toLowerCase()),
            phone: () => this.userData.phone.length >= 9,
            seriesAndNumberOfIdentityCard: () => this.userData.shipment.charge_deposit || this.userData.seriesAndNumberOfIdentityCard !== '',
            secondIdentityDocument: () => {
                if (this.userData.shipment.charge_deposit) {
                    return true;
                }

                if (this.userData.secondIdentityDocument !== '') {
                    if (this.userData.secondIdentityDocument == 5 && this.userData.secondIdentityDocumentType === '') {
                        return false;
                    }

                    return true;
                }

                return false;
            },
            seriesAndNumberOfSecondIdentityDocument: () => this.userData.shipment.charge_deposit || this.userData.seriesAndNumberOfSecondIdentityDocument !== '',
            shipment_1_street: () => !this.userData.shipment_1 || this.userData.shipment_1_street !== '',
            shipment_1_houseNumber: () => !this.userData.shipment_1 || this.userData.shipment_1_houseNumber !== '',
            shipment_1_zipCode: () => !this.userData.shipment_1 || this.userData.shipment_1_zipCode !== '',
            shipment_1_city: () => !this.userData.shipment_1 || this.userData.shipment_1_city !== '',
            shipment_2_street: () => !this.userData.shipment_2 || this.userData.shipment_2_street !== '',
            shipment_2_houseNumber: () => !this.userData.shipment_2 || this.userData.shipment_2_houseNumber !== '',
            shipment_2_zipCode: () => !this.userData.shipment_2 || this.userData.shipment_2_zipCode !== '',
            shipment_2_city: () => !this.userData.shipment_2 || this.userData.shipment_2_city !== ''
        };

        this.price = {
            price: 0,
            shipment: 0,
            deposit: 0
        };

        this.orderId = null;
        this.payment = '';
    }

    load() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/rental/get-product-info',
            {
                productId: rentalProductId
            }
        ).then(
            (response) => {
                const data = response.data.data;

                this.product = data;
                this.price.deposit = data.deposit;
                this.loaded = true;
                this.loading = false;

                deferred.resolve({
                    product: data
                });
            },
            (response) => {
                this.loading = false;
                this.loaded = true;

                if (response.status === 404) {
                    this.product = null;

                    deferred.resolve({
                        product: null
                    });

                    return;
                }

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setShipment(shipment) {
        this.userData.shipment = shipment;
    }

    setPayment(payment) {
        this.userData.payment = payment;
    }

    calculatePrice() {
        const deferred = this.$q.defer();

        this.$http.post(
            '/ajax/rental/calculate-product-price',
            {
                productId: this.product.id,
                rentalPeriodFrom: this.userData.rentalPeriodFrom,
                rentalPeriodTo: this.userData.rentalPeriodTo
            }
        ).then(
            (response) => {
                const data = response.data.data;

                this.price.price = parseFloat(data.price);

                deferred.resolve({
                    price: data.price
                });
            },
            (response) => {
                if (response.status === 404) {
                    this.price.price = 0;

                    deferred.resolve({
                        price: 0
                    });

                    return;
                }

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    submit() {
        if (!this.complete) {
            return;
        }

        const deferred = this.$q.defer();

        this.loading = true;

        this.$http.post(
            '/ajax/rental/finalize-order',
            {...this.userData, ...this.product, ...{price: this.price}}
        ).then(
            (response) => {
                this.loading = false;

                if (response.data && response.data.message && response.data.message.type === 'error') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 15000);

                    deferred.reject('Błędne dane!');

                    return;
                }

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const orderId = response.data.data.orderId;

                this.orderId = orderId;
                this.payment = response.data.data.payment;

                deferred.resolve({ orderId });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    get complete() {
        if (!this.userData.shipment) {
            return false;
        }

        if (!this.userData.payment) {
            return false;
        }

        if (!this.userData.acceptTerms) {
            return false;
        }

        for (const validatorFnName in this.userDataValidations) {
            if (!this.userDataValidations[validatorFnName]()) {
                return false;
            }
        }

        return true;
    }
}

export default RentalService;